const storageKeys = {
    showBasicSlidesPreview: 'config.navigationPreview.show',
};

const storage = localStorage;

export const getShowBasicSlidesPreview = (): boolean =>
    storage.getItem(storageKeys.showBasicSlidesPreview)?.toLocaleLowerCase() ===
    'true';
export const setShowBasicSlidesPreview = (show: undefined | boolean) => {
    if (show === undefined) {
        storage.removeItem(storageKeys.showBasicSlidesPreview);
    } else {
        storage.setItem(storageKeys.showBasicSlidesPreview, '' + show);
    }
};
